import type { PropsWithChildren } from 'react';
import { memo } from 'react';

import type { CardProps } from '../../Card';
import { Card } from '../../Card';
import { InfoTooltip } from '../../Tooltip';
import styles from './InfoCard.module.scss';

interface InfoCardProps extends CardProps, PropsWithChildren {
  caption?: string;
  tooltip?: string;
}

const InfoCard = memo(({ caption, tooltip, children, ...cardProps }: InfoCardProps) => {
  return (
    <Card {...cardProps}>
      <div className={styles['header']}>
        {caption && <div className={styles['caption']}>{caption}</div>}
        {tooltip && (
          <div className={styles['tooltip']}>
            <InfoTooltip message={tooltip} portalMode="overlay" />
          </div>
        )}
      </div>
      {children}
    </Card>
  );
});

export { InfoCard, type InfoCardProps };
